import type { CanvasMapAdapter } from './CanvasMapAdapter';

const CANVAS_MAP_HOST_HANDLE_KEY = '__geosoft_canvas_map_adapter';

export function setCanvasMapHostHandle(
  container: HTMLElement,
  adapter: CanvasMapAdapter,
): void {
  (container as unknown as Record<string, unknown>)[CANVAS_MAP_HOST_HANDLE_KEY] = adapter;
}

export function getCanvasMapHostHandle(container: HTMLElement): CanvasMapAdapter | null {
  const value = (container as unknown as Record<string, unknown>)[CANVAS_MAP_HOST_HANDLE_KEY];
  return value ? (value as CanvasMapAdapter) : null;
}

export function clearCanvasMapHostHandle(container: HTMLElement): void {
  delete (container as unknown as Record<string, unknown>)[CANVAS_MAP_HOST_HANDLE_KEY];
}
